import React from 'react';
import AboutContent from '../components/AboutContent/AboutContent';
import MotionContainer from '../components/Motion/MotionContainer';
import Section from '../components/Section/Section';

const About = () => {
  return (
    <MotionContainer>
      <Section title="About Me">
        <AboutContent />
      </Section>
    </MotionContainer>
  );
};

export default About;
